import { render, staticRenderFns } from "./ofertas-detalle.vue?vue&type=template&id=23a73cd2&lang=html"
import script from "./ofertas-detalle.vue?vue&type=script&lang=js"
export * from "./ofertas-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports